<div [class.editable-cell]="!isReadOnly"
     [class.bold]="isReadOnly"
     [class.pop-disabled-cell]="isCellDisabled"
     class="cell pop-text-align-right"
     [matTooltip]="tooltip"
     matTooltipClass="pop-tooltip">
  <input *ngIf="isEditable"
         #input
         pInputText
         type="number"
         placeholder="-"
         [(ngModel)]="rowData.totals[field]"
         (ngModelChange)="userInput($event)"
         (focus)="input.select()"
         (blur)="onBlur()" />
  <ng-container *ngIf="!isEditable">
    {{ getValue() }}
  </ng-container>
</div>
